import { useTable } from "react-table";
import CustomButton from "./CustomButton";

const CustomTable = ({ columns, data, onEdit }) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data,
  });
  return (
    data && (
      <table {...getTableProps()} style={{maxHeight: '300px'}}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
              <th></th>
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                  );
                })}
                <td>
                  <CustomButton
                    type="button"
                    invert
                    onClick={() => onEdit(row.original)}
                    style={{width: '100%'}}
                  >
                    Edit
                  </CustomButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    )
  );
};

export default CustomTable;
